import React, { useState, useEffect } from "react";
import CentralDashboardService from "../../services/centraldashboard.service";
import "chart.js/auto";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";

const VehicleStatusList = () => {
  const currentDate = new Date();
  const [mainData, setMainData] = useState([]);
  const [depoList, setDepoList] = useState([]);
  const [underMain, setUnderMain] = useState([]);
  const [doneMain, setDoneMain] = useState([]);
  const [sevenDays, setSevenDays] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendar2, setShowCalendar2] = useState(false);

  const [formdate, setFormdate] = useState(
    moment(new Date(currentDate)).format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    moment(new Date(currentDate)).format("YYYY-MM-DD")
  );

  const [details, setDetails] = useState({
    fromDate: moment(new Date(currentDate)).format("YYYY-MM-DD"),
    formatedFromDate: moment(new Date(currentDate)).format("DD-MM-YY"),
    toDate: moment(new Date(currentDate)).format("YYYY-MM-DD"),
    formatedToDate: moment(new Date(currentDate)).format("DD-MM-YY"),
  });

  useEffect(() => {
    fetchData();
  }, [details, , formdate, toDate]);

  const fetchData = () => {
    const req = {
      fromdate: details.fromDate,
      todate: details.toDate,
    };
    CentralDashboardService.getVehicleStatus(req)
      .then((response) => {
        if (response) {
          setMainData(response.data);
          setDepoList(response.data.map((item) => item.locname));
          setUnderMain(response.data.map((item) => item.underrepaire));
          setDoneMain(response.data.map((item) => item.fixed));
          setSevenDays(response.data.map((item) => item.underrepairemorethan7));
        }
      })
      .catch((e) => console.log(e));
  };

  // const formatMonthYear = (locale, date) => {
  //   return `${currentDate.getDate()} ${currentDate.toLocaleDateString(locale, {
  //     month: "long",
  //   })}, ${currentDate.getFullYear()}`;
  // };

  const handleChange = (newValue) => {
    setFormdate(newValue);

    setDetails({
      ...details,
      fromDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });

    setShowCalendar(false);
  };

  const handleChange2 = (newValue) => {
    setToDate(newValue);
    setDetails({
      ...details,
      toDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar2(false);
  };

  return (
    <>
      <div style={{ width: "75%" }}>
        <div className="graph-header mb-3">
          <div className="graph-heading">Vehicle Maintenance Records</div>
          <div
            className={`${
              showCalendar || showCalendar2 ? "modal-overlay" : ""
            }`}
            onClick={(e) => {
              setShowCalendar2(false);
              setShowCalendar(false);
            }}
          >
            <div className="" onClick={(e) => e.stopPropagation()}></div>
          </div>
          <div className="date-range" style={{ display: "flex" }}>
            <div className="flex position-relative">
              <span>
                {details.formatedFromDate !== ""
                  ? details.formatedFromDate
                  : "From"}
              </span>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(e) => {
                    setShowCalendar(true);
                    setShowCalendar2(false);
                  }}
                >
                  <path
                    d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.83333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                    stroke="#6E6284"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              {showCalendar && (
                <div className="calendarModal position-absolute">
                  <Calendar
                    // formatMonthYear={formatMonthYear}
                    onChange={handleChange}
                    value={formdate}
                    maxDate={currentDate}
                  />
                </div>
              )}
            </div>
            <div className="flex position-relative">
              <span>
                {details.formatedToDate !== "" ? details.formatedToDate : "To"}
              </span>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(e) => {
                    setShowCalendar2(true);
                    setShowCalendar(false);
                  }}
                >
                  <path
                    d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.83333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                    stroke="#6E6284"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              {showCalendar2 && (
                <div className="calendarModal position-absolute">
                  <Calendar
                    // formatMonthYear={formatMonthYear}
                    onChange={handleChange2}
                    value={toDate}
                    minDate={formdate}
                    maxDate={currentDate}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="table">
          <div className="table-header">
            <div className="tbody" style={{ width: "80%" }}>
              <span>Depot Name</span>
            </div>
            <div className="grey-line"></div>
            <div className="tbody">
              <span>Under Maintenance</span>
            </div>
            <div className="grey-line"></div>
            <div className="tbody">
              <span>
                Maintenance
                <br /> Completed
              </span>
            </div>
            {/* <div className="grey-line"></div>
          <div className="tbody">
            <div className="d-flex flex-column align-items-center">
              <span>Under Maintenance</span>
              <span>( {">"} 7 Days )</span>
            </div>
          </div> */}
          </div>

          {mainData.length != 0 ? (
            <div className="table-body">
              <div className="tbody" style={{ width: "80%" }}>
                {depoList.length != 0
                  ? depoList.map((item) => (
                      <div className="depot-name">
                        <span className="text">{item}</span>
                        {/* <span>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.41602 15.5834L15.5827 6.41675M15.5827 6.41675H7.33268M15.5827 6.41675V14.6668"
                    stroke="#4E465E"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span> */}
                      </div>
                    ))
                  : null}
              </div>
              <div className="tbody">
                {underMain.length !== 0
                  ? underMain.map((item) => (
                      <div className="">
                        <span className="text">{item}</span>
                        <span>
                          <svg
                            width="30"
                            height="25"
                            viewBox="0 0 39 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1901_6124)">
                              <path
                                d="M34.125 16.5H4.875V24.75H34.125V16.5Z"
                                fill="#F76D57"
                              />
                              <path
                                d="M34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                                fill="#F9EBB2"
                              />
                              <path
                                d="M29.25 22.6875C30.5962 22.6875 31.6875 21.7641 31.6875 20.625C31.6875 19.4859 30.5962 18.5625 29.25 18.5625C27.9038 18.5625 26.8125 19.4859 26.8125 20.625C26.8125 21.7641 27.9038 22.6875 29.25 22.6875Z"
                                fill="#394240"
                              />
                              <path
                                d="M9.75 22.6875C11.0962 22.6875 12.1875 21.7641 12.1875 20.625C12.1875 19.4859 11.0962 18.5625 9.75 18.5625C8.40381 18.5625 7.3125 19.4859 7.3125 20.625C7.3125 21.7641 8.40381 22.6875 9.75 22.6875Z"
                                fill="#394240"
                              />
                              <path
                                d="M31.6875 0H7.3125C3.27539 0 0 2.76942 0 6.1875V26.8125C0 27.9525 1.09017 28.875 2.4375 28.875H4.875V30.9375C4.875 32.0775 5.96517 33 7.3125 33H9.75C11.0973 33 12.1875 32.0775 12.1875 30.9375V28.875H26.8125V30.9375C26.8125 32.0775 27.9027 33 29.25 33H31.6875C33.0348 33 34.125 32.0775 34.125 30.9375V28.875H36.5625C37.9098 28.875 39 27.9525 39 26.8125V6.1875C39 2.77148 35.727 0 31.6875 0ZM34.125 24.75H4.875V16.5H34.125V24.75ZM34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                                fill="#394240"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1901_6124">
                                <rect width="39" height="33" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                    ))
                  : null}
              </div>
              <div className="tbody">
                {doneMain.length !== 0
                  ? doneMain.map((item) => (
                      <div className="">
                        <span className="text">{item}</span>
                        <span>
                          <svg
                            width="30"
                            height="25"
                            viewBox="0 0 39 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1901_6145)">
                              <path
                                d="M34.125 16.5H4.875V24.75H34.125V16.5Z"
                                fill="#64DDA9"
                              />
                              <path
                                d="M34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                                fill="#F9EBB2"
                              />
                              <path
                                d="M29.25 22.6875C30.5962 22.6875 31.6875 21.7641 31.6875 20.625C31.6875 19.4859 30.5962 18.5625 29.25 18.5625C27.9038 18.5625 26.8125 19.4859 26.8125 20.625C26.8125 21.7641 27.9038 22.6875 29.25 22.6875Z"
                                fill="#394240"
                              />
                              <path
                                d="M9.75 22.6875C11.0962 22.6875 12.1875 21.7641 12.1875 20.625C12.1875 19.4859 11.0962 18.5625 9.75 18.5625C8.40381 18.5625 7.3125 19.4859 7.3125 20.625C7.3125 21.7641 8.40381 22.6875 9.75 22.6875Z"
                                fill="#394240"
                              />
                              <path
                                d="M31.6875 0H7.3125C3.27539 0 0 2.76942 0 6.1875V26.8125C0 27.9525 1.09017 28.875 2.4375 28.875H4.875V30.9375C4.875 32.0775 5.96517 33 7.3125 33H9.75C11.0973 33 12.1875 32.0775 12.1875 30.9375V28.875H26.8125V30.9375C26.8125 32.0775 27.9027 33 29.25 33H31.6875C33.0348 33 34.125 32.0775 34.125 30.9375V28.875H36.5625C37.9098 28.875 39 27.9525 39 26.8125V6.1875C39 2.77148 35.727 0 31.6875 0ZM34.125 24.75H4.875V16.5H34.125V24.75ZM34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                                fill="#394240"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1901_6145">
                                <rect width="39" height="33" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                    ))
                  : null}
              </div>
              {/* <div className="tbody">
              {sevenDays.length !== 0
                ? sevenDays.map((item) => (
                    <div className="">
                      <span className="text">{item}</span>
                      <span>
                        <svg
                          width="30"
                          height="25"
                          viewBox="0 0 39 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1901_6124)">
                            <path
                              d="M34.125 16.5H4.875V24.75H34.125V16.5Z"
                              fill="#F76D57"
                            />
                            <path
                              d="M34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                              fill="#F9EBB2"
                            />
                            <path
                              d="M29.25 22.6875C30.5962 22.6875 31.6875 21.7641 31.6875 20.625C31.6875 19.4859 30.5962 18.5625 29.25 18.5625C27.9038 18.5625 26.8125 19.4859 26.8125 20.625C26.8125 21.7641 27.9038 22.6875 29.25 22.6875Z"
                              fill="#394240"
                            />
                            <path
                              d="M9.75 22.6875C11.0962 22.6875 12.1875 21.7641 12.1875 20.625C12.1875 19.4859 11.0962 18.5625 9.75 18.5625C8.40381 18.5625 7.3125 19.4859 7.3125 20.625C7.3125 21.7641 8.40381 22.6875 9.75 22.6875Z"
                              fill="#394240"
                            />
                            <path
                              d="M31.6875 0H7.3125C3.27539 0 0 2.76942 0 6.1875V26.8125C0 27.9525 1.09017 28.875 2.4375 28.875H4.875V30.9375C4.875 32.0775 5.96517 33 7.3125 33H9.75C11.0973 33 12.1875 32.0775 12.1875 30.9375V28.875H26.8125V30.9375C26.8125 32.0775 27.9027 33 29.25 33H31.6875C33.0348 33 34.125 32.0775 34.125 30.9375V28.875H36.5625C37.9098 28.875 39 27.9525 39 26.8125V6.1875C39 2.77148 35.727 0 31.6875 0ZM34.125 24.75H4.875V16.5H34.125V24.75ZM34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                              fill="#394240"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1901_6124">
                              <rect width="39" height="33" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </div>
                  ))
                : null}
            </div> */}
            </div>
          ) : (
            <div
              className="table-body align-items-center"
              style={{ height: "100%" }}
            >
              No Records Found
            </div>
          )}
        </div>
      </div>
      <div style={{ width: "25%" }}>
        <div className="" style={{ marginBottom: "40px" }}></div>
        <div className="table">
          <div className="table-header">
            <div className="tbody">
              <div className="d-flex flex-column align-items-center">
                <span>Under Maintenance</span>
                <span>( {">"} 7 Days )</span>
              </div>
            </div>
          </div>

          {mainData.length != 0 ? (
            <div className="table-body">
              <div className="tbody">
                {sevenDays.length !== 0
                  ? sevenDays.map((item) => (
                      <div className="">
                        <span className="text">{item}</span>
                        <span>
                          <svg
                            width="30"
                            height="25"
                            viewBox="0 0 39 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1901_6124)">
                              <path
                                d="M34.125 16.5H4.875V24.75H34.125V16.5Z"
                                fill="#F76D57"
                              />
                              <path
                                d="M34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                                fill="#F9EBB2"
                              />
                              <path
                                d="M29.25 22.6875C30.5962 22.6875 31.6875 21.7641 31.6875 20.625C31.6875 19.4859 30.5962 18.5625 29.25 18.5625C27.9038 18.5625 26.8125 19.4859 26.8125 20.625C26.8125 21.7641 27.9038 22.6875 29.25 22.6875Z"
                                fill="#394240"
                              />
                              <path
                                d="M9.75 22.6875C11.0962 22.6875 12.1875 21.7641 12.1875 20.625C12.1875 19.4859 11.0962 18.5625 9.75 18.5625C8.40381 18.5625 7.3125 19.4859 7.3125 20.625C7.3125 21.7641 8.40381 22.6875 9.75 22.6875Z"
                                fill="#394240"
                              />
                              <path
                                d="M31.6875 0H7.3125C3.27539 0 0 2.76942 0 6.1875V26.8125C0 27.9525 1.09017 28.875 2.4375 28.875H4.875V30.9375C4.875 32.0775 5.96517 33 7.3125 33H9.75C11.0973 33 12.1875 32.0775 12.1875 30.9375V28.875H26.8125V30.9375C26.8125 32.0775 27.9027 33 29.25 33H31.6875C33.0348 33 34.125 32.0775 34.125 30.9375V28.875H36.5625C37.9098 28.875 39 27.9525 39 26.8125V6.1875C39 2.77148 35.727 0 31.6875 0ZM34.125 24.75H4.875V16.5H34.125V24.75ZM34.125 12.375H4.875V6.1875C4.875 5.04745 5.96517 4.125 7.3125 4.125H31.6875C33.0348 4.125 34.125 5.04745 34.125 6.1875V12.375Z"
                                fill="#394240"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1901_6124">
                                <rect width="39" height="33" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                    ))
                  : null}
              </div>
            </div>
          ) : (
            <div
              className="table-body align-items-center"
              style={{ height: "100%" }}
            >
              No Records Found
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VehicleStatusList;
